module.exports = __webpack_public_path__ + "static/man2man-0776467166da77b4fdf736d7dcc181e1.jpg";